if (!customElements.get('zeya-community-edit')) {
  customElements.define('zeya-community-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.looks = [...this.querySelectorAll('.zec-look')];
      this.notes = [...this.querySelectorAll('.zec-note')];
      this.lookIndex = 0;
      this.noteIndex = 0;
      const lookNav = this.querySelector('.zec-look-nav');
      const noteNav = this.querySelector('.zec-note-nav');
      if (lookNav) lookNav.hidden = false;
      if (noteNav) noteNav.hidden = false;
      this.querySelectorAll('[data-look-step]').forEach(button => {
        button.addEventListener('click', () => {
          this.lookIndex = (this.lookIndex + Number(button.dataset.lookStep) + this.looks.length) % this.looks.length;
          this.drawLooks();
        });
      });
      this.querySelectorAll('[data-note-step]').forEach(button => {
        button.addEventListener('click', () => {
          this.noteIndex = (this.noteIndex + Number(button.dataset.noteStep) + this.notes.length) % this.notes.length;
          this.drawNotes();
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const look = event.target.closest('.zec-look');
        const note = event.target.closest('.zec-note');
        if (look && this.looks.includes(look)) { this.lookIndex = this.looks.indexOf(look); this.drawLooks(); }
        if (note && this.notes.includes(note)) { this.noteIndex = this.notes.indexOf(note); this.drawNotes(); }
      });
      this.drawLooks();
      this.drawNotes();
    }
    drawLooks() {
      const length = this.looks.length;
      this.looks.forEach((look, index) => {
        const order = (index - this.lookIndex + length) % length;
        look.dataset.mobileVisible = String(order < 2);
        look.style.order = order;
      });
      const count = this.querySelector('.zec-look-count');
      if (count) count.textContent = count.dataset.format.replace('__first__', this.lookIndex + 1).replace('__last__', (this.lookIndex + 1) % length + 1).replace('__total__', length);
    }
    drawNotes() {
      this.notes.forEach((note, index) => { note.hidden = index !== this.noteIndex; });
      const count = this.querySelector('.zec-note-count');
      if (count) count.textContent = count.dataset.format.replace('__current__', this.noteIndex + 1).replace('__total__', this.notes.length);
    }
  });
}
